import { ChangeDetectorRef, Component } from '@angular/core';
import { EtlIngestionService } from '../../services/etl-ingestion/etl-ingestion.service';
import { AppService } from '../../app.service';
import { catchError, finalize, of, tap } from 'rxjs';
import { CampaignTrackersService } from '../../services/campaign-trackers/campaign-trackers.service';

@Component({
  selector: 'app-campaign-trackers',
  templateUrl: './campaign-trackers.component.html',
  styleUrl: './campaign-trackers.component.css'
})
export class CampaignTrackersComponent {
    isSideBarVisible: boolean = false;
    isDeleteModalVisible: boolean = false;
    toDeleteItem:any;
    editedId: number = 0;
    selectedCreditorId:string = '';
    campaignTrackers!: any[]; 

    firstName: string = '';
    lastName: string = '';
    email: string = '';

    page: number = 1;
    rows: number = 10;
    totalRecords: number = 100;

  public constructor(
    private etlIngestionService: EtlIngestionService, 
    private appService: AppService, 
    private campaignTrackersService: CampaignTrackersService,
    private cdr: ChangeDetectorRef) { }

  ngOnInit() {
  }

  onSelectCreditor(creditorId: string){
    this.campaignTrackers = [];
    this.selectedCreditorId = creditorId;
  }

  search(){
    if(!!this.selectedCreditorId){
      //this.appService.isShowPageSpinner = true;
      this.campaignTrackers = [
        {
          campaignTrackerId: 9328,
          creditorId: 15,
          campaignId: 110373,
          scheduleId: 160592,
          automationCampaignId: 58,
          playbookEntryId: 1210,
          playbookId: 57,
          daysFromStart: 13,
          recipientCount: 23934,
          rejectedMobileMessageCount: null,
          rejectedEmailCount: null,
          name: "Email - Snap Finance, LLC - (05/02) Automation 58 Playbook 57 Entry 1210 Day 13",
          emailCommsPlatformId: "SendGrid",
          smsCommsPlatformId: "Twilio",
          communicationChannels: "Email",
          snapshotExpiryOnUtc: "2025-05-05T15:20:00",
          campaignStartTimeUtc: "2025-05-02T15:20:00",
          campaignFinishTimeUtc: null,
          completionMessage: null,
          campaignPreparedUtc: null,
          isApproved: false,
          cancelledOnUtc: null,
          cancelledBy: null,
          cancellationReason: null,
          createdOnUtc: "2025-05-02T05:12:00",
          createdBy: "Campaign.Api",
          updatedOnUtc: null,
          updatedBy: null,
          deletedOnUtc: null,
          deletedBy: null,
          campaign: null,
          campaignSchedule: null,
          campaignMessageStatus: null,
          campaignPipeline: null
        },
        {
          campaignTrackerId: 9327,
          creditorId: 9,
          campaignId: 110372,
          scheduleId: 160591,
          automationCampaignId: 61,
          playbookEntryId: 1265,
          playbookId: 46,
          daysFromStart: 13,
          recipientCount: 172,
          rejectedMobileMessageCount: null,
          rejectedEmailCount: null,
          name: "Email - Happy Money - (05/02) Automation 61 Playbook 46 Entry 1265 Day 13",
          emailCommsPlatformId: "SendGrid",
          smsCommsPlatformId: "Twilio",
          communicationChannels: "Email",
          snapshotExpiryOnUtc: "2025-05-05T16:40:00",
          campaignStartTimeUtc: "2025-05-02T16:40:00",
          campaignFinishTimeUtc: null,
          completionMessage: null,
          campaignPreparedUtc: null,
          isApproved: false,
          cancelledOnUtc: null,
          cancelledBy: null,
          cancellationReason: null,
          createdOnUtc: "2025-05-02T05:12:00",
          createdBy: "Campaign.Api",
          updatedOnUtc: null,
          updatedBy: null,
          deletedOnUtc: null,
          deletedBy: null,
          campaign: null,
          campaignSchedule: null,
          campaignMessageStatus: null,
          campaignPipeline: null
        },
        {
          campaignTrackerId: 9326,
          creditorId: 9,
          campaignId: 110371,
          scheduleId: 160590,
          automationCampaignId: 61,
          playbookEntryId: 1264,
          playbookId: 46,
          daysFromStart: 12,
          recipientCount: 1,
          rejectedMobileMessageCount: null,
          rejectedEmailCount: null,
          name: "Email - Happy Money - (05/02) Automation 61 Playbook 46 Entry 1264 Day 12",
          emailCommsPlatformId: "SendGrid",
          smsCommsPlatformId: "Twilio",
          communicationChannels: "Email",
          snapshotExpiryOnUtc: "2025-05-05T17:45:00",
          campaignStartTimeUtc: "2025-05-02T17:45:00",
          campaignFinishTimeUtc: null,
          completionMessage: null,
          campaignPreparedUtc: null,
          isApproved: false,
          cancelledOnUtc: null,
          cancelledBy: null,
          cancellationReason: null,
          createdOnUtc: "2025-05-02T05:12:00",
          createdBy: "Campaign.Api",
          updatedOnUtc: null,
          updatedBy: null,
          deletedOnUtc: null,
          deletedBy: null,
          campaign: null,
          campaignSchedule: null,
          campaignMessageStatus: null,
          campaignPipeline: null
        }];

    //   this.campaignTrackersService.get()
    //     .pipe(
    //       tap((res: any ) => {
    //         if(!!res && !!res.items && Array.isArray(res.items) && res.items.length > 0){
    //           this.campaignTrackers = res.items;
    //         }  
    //       }),
    //       catchError(error => {          
    //         this.appService.openCommonModal('Error','There seems to be an error getting the Notification Contacts.');
    //         return of(null); 
    //       }),
    //       finalize(() => {   
    //         this.appService.isShowPageSpinner = false;
    //       })
    //     ).subscribe();
    }
  }

  onPageChange(event: any) {
    this.page = event.page+1;
    this.rows = event.rows;
    this.search();
  }
}
